import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import Stack from "@mui/material/Stack";
import Button from "@mui/material/Button";
import { useState, useEffect } from "react";
import { Outlet } from "react-router-dom";
import axios from "axios";
import Cookies from "js-cookie";
import InputAdornment from "@mui/material/InputAdornment";
import IconButton from "@mui/material/IconButton";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";

// Pages
import ForgotPass from "../components/ForgotPass";
import Login from "../components/Login";

// Router
import { Link, useNavigate } from "react-router-dom";

// Image
import tvc_Logo from "../photos/tvc_logo.png";

import loginCover from "../photos/login_cover.jpg";
export default function Signin() {
  const baseURL = process.env.REACT_APP_BASE_URL;

  const [user, setUser] = useState({ user_email: "", user_password: "" });

  const [message, setMessage] = useState("");
  const navigate = useNavigate(); // Initialize useNavigate for redirect
  useEffect(() => {
    axios
      .get(`${baseURL}/decode-token`, { withCredentials: true }) // Request user_id from backend
      .then((response) => {
        navigate(`/profile/${response.data.user_id}`, { replace: true });
        window.location.reload(); // Redirect to profile

        // if (response.data.user_role == "admin") {
        //   navigate("/admin/dashboard");
        //   window.location.reload(); // Redirect to profile
        // }
      })
      .catch((error) => {});
  }, [navigate]);
  return (
    <div className="Signin full_Screen">
      <Stack
        direction={{ xs: "column", md: "row" }}
        minHeight="100dvh"
        sx={{
          backgroundImage: {
            xs: `url(${loginCover})`,
            md: "none",
          },
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      >
        {/* Desktop image column */}
        <Box
          sx={{
            flex: 1,
            display: { xs: "none", md: "block" },
          }}
        >
          <Box
            component="img"
            src={loginCover}
            alt="loginCover"
            sx={{
              width: "100%",
              height: "100%",
              objectFit: "cover",
            }}
          />
        </Box>

        {/* Outlet */}
        <Box
          sx={{
            flex: 1,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            p: { xs: 2, sm: 3 },
            height: "fit-content",
          }}
        >
          {/* Card wrapper */}
          <Box
            sx={{
              width: "100%",
              maxWidth: 380,
              backgroundColor: "#fff",
              borderRadius: 3,
              boxShadow: {
                xs: "0 8px 24px rgba(0,0,0,0.2)",
                md: "none",
              },
              p: { xs: 3, sm: 4 },
            }}
          >
            <Outlet />
          </Box>
        </Box>
      </Stack>
    </div>
  );
}
